import { useEffect, useRef } from 'react';

const WarningBanner = () => {
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateHeight = () => {
      if (bannerRef.current) {
        document.documentElement.style.setProperty('--warning-banner-height', `${bannerRef.current.offsetHeight}px`);
      }
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <div
      ref={bannerRef}
      className="fixed top-0 left-0 right-0 z-[60] bg-yellow-500 text-black py-2 px-2 md:px-4 text-center text-[10px] md:text-xs lg:text-sm font-semibold leading-tight"
    >
      <p className=" mx-auto">
        JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX: PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION.{' '}
        RETROUVEZ NOS CONSEILS SUR{' '}
        <a
          href="https://www.joueurs-info-service.fr/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-yellow-800 transition-colors"
        >
          JOUEURS-INFO-SERVICE.FR
        </a>{' '}
        (09 74 75 13 13 - APPEL NON SURTAXÉ)
      </p>
    </div>
  );
};

export default WarningBanner;
